 // import Swiper JS
 import Swiper, {
   Autoplay,
   Navigation
 } from 'swiper';
 // import Swiper styles
 import 'swiper/css';

 // configure Swiper to use modules
 Swiper.use([Autoplay, Navigation]);

 export function initImageTextCarousel() {
   if (window.acf) {
     window.acf.addAction(
       'render_block_preview/type=image-and-text-carousel',
       imageTextCarousel
     );
   }
 }

 export function imageTextCarousel() {

   if (!document.querySelector('.carousel-image-text'))
     return;

   const swiper = new Swiper('.carousel-image-text', {
     // Optional parameters
     slidesPerView: 1,
     slidesPerGroup: 1,
     autoplay: {
       delay: 7000,
     },
     loop: true,
     navigation: {
       nextEl: '.carousel-image-text-prev',
       prevEl: '.carousel-image-text-next',
     },
   });
 }
